module.exports = __webpack_public_path__ + "img/proship_logo.19250e3a.png";